module.exports = __webpack_public_path__ + "static/media/livraison-a-domicile.00170195.svg";